import {toast} from 'react-toastify';

import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { getCookie } from '../common/enum';

const ACTIONS = {
    GET_DATA_COMPANY_SUCCESS: 'GET_DATA_COMPANY_SUCCESS',
    GET_DATA_COMPANY_ERROR: 'GET_DATA_COMPANY_ERROR',
    POST_DATA_COMPANY_SUCCESS: 'POST_DATA_COMPANY_SUCCESS',
    POST_DATA_COMPANY_ERROR: 'POST_DATA_COMPANY_ERROR',
    UPDATE_DATA_COMPANY_SUCCESS: 'UPDATE_DATA_COMPANY_SUCCESS',
    UPDATE_DATA_COMPANY_ERROR: 'UPDATE_DATA_COMPANY_ERROR',
    REMOVE_DATA_COMPANY_SUCCESS: 'REMOVE_DATA_COMPANY_SUCCESS',
    REMOVE_DATA_COMPANY_ERROR: 'REMOVE_DATA_COMPANY_ERROR',
    GET_DATA_CLIENT_SUCCESS: 'GET_DATA_CLIENT_SUCCESS',
    GET_DATA_CLIENT_ERROR: 'GET_DATA_CLIENT_ERROR',
    ADD_DATA_CLIENT_SUCCESS: 'ADD_DATA_CLIENT_SUCCESS',
    ADD_DATA_CLIENT_ERROR: 'ADD_DATA_CLIENT_ERROR',
    UPDATE_DATA_CLIENT_SUCCESS: 'UPDATE_DATA_CLIENT_SUCCESS',
    UPDATE_DATA_CLIENT_ERROR: 'UPDATE_DATA_CLIENT_ERROR',
    DELETE_DATA_CLIENT_SUCCESS: 'DELETE_DATA_CLIENT_SUCCESS',
    DELETE_DATA_CLIENT_ERROR: 'DELETE_DATA_CLIENT_ERROR',
};

const updateStatus = (type, data) => ({
    type,
    data,
});

const getAllCompanyAdmin = () => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    return (dispatch) => {
        callApi(`${host.serverTest}api/admin/customers/companies`,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_COMPANY_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_COMPANY_ERROR, err));
            });
    };
}

const getAdminClient = (query) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    return (dispatch) => {
        callApi(`${host.serverTest}api/admin/customers/users${query}`,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_CLIENT_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_CLIENT_ERROR, err));
            });
    };
}

const searchCompany = (text) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    return (dispatch) => {
        callApi(`${host.serverTest}api/admin/customers/companies?keyword=${text}`,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_COMPANY_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_COMPANY_ERROR, err));
            });
    };
}

const searchClient = (text) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    return (dispatch) => {
        callApi(`${host.serverTest}api/admin/customers/users?keyword=${text}`,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_CLIENT_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_CLIENT_ERROR, err));
            });
    };
}

const addCompany = (data) => {
    const config = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
        body: JSON.stringify({
            name: data.name,
            code: data.code,
        })
    };
    return (dispatch) => {
        callApi(`${host.serverTest}api/admin/customers/companies`, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.POST_DATA_COMPANY_SUCCESS, data));
                if(data.message) {
                    toast.error(data.message);
                    return;
                }
                toast.success('企業を追加しました')
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.POST_DATA_COMPANY_ERROR, err));
                toast.error(err.message)
            });
    };
}

const addClientAdmin = (data) => {
    const config = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
        body: JSON.stringify({
            name: data.name,
            email: data.email,
            password: data.password
        })
    };
    return (dispatch) => {
        callApi(`${host.serverTest}api/admin/customers/users`, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.ADD_DATA_CLIENT_SUCCESS, data));
                if(data.message) {
                    toast.error(data.message);
                    return;
                }
                toast.success('利用者を追加しました');
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.ADD_DATA_CLIENT_ERROR, err));
                toast.error(err.message);
            });
    };
}

const removeCompany = (id) => {
    const config = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    return (dispatch) => {
        callApi(`${host.serverTest}api/admin/customers/companies/${id}`, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.REMOVE_DATA_COMPANY_SUCCESS, data));
                toast.success('企業を削除しました');
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.REMOVE_DATA_COMPANY_ERROR, err));
                toast.success(err.message);
            });
    };
}

const deleteClientAdmin = (id) => {
    const config = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    return (dispatch) => {
        callApi(`${host.serverTest}api/admin/customers/users/${id}`, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.DELETE_DATA_CLIENT_SUCCESS, data));
                toast.success('利用者を削除しました');
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.DELETE_DATA_CLIENT_ERROR, err));
                toast.success(err.message);
            });
    };
}

const updateCompany = (data) => {
    const config = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
        body: JSON.stringify({
            name: data.name,
            code: data.code,
        })
    };

    return (dispatch) => {
        callApi(`${host.serverTest}api/admin/customers/companies/${data.id}`, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.UPDATE_DATA_COMPANY_SUCCESS, data));
                if(data.message) {
                    toast.error(data.message);
                    return;
                }
                toast.success('企業を編集しました');
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.UPDATE_DATA_COMPANY_ERROR, err));
                toast.error(err.message);
            });
    };
}

const updateClientAdmin = (data, id) => {
    const config = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
        body: JSON.stringify({
            name: data.name,
            email: data.email,
            password: data.password || null
        })
    };

    return (dispatch) => {
        callApi(`${host.serverTest}api/admin/customers/users/${id}`, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.UPDATE_DATA_CLIENT_SUCCESS, data));
                toast.success('利用者を編集しました');
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.UPDATE_DATA_CLIENT_ERROR, err));
                toast.error(err.message);
            });
    };
}

const convertAdminClient = (data) => {
    return data.map((items, index) => {
        return {
            item: [
                { text: items.name, id: items.id },
                { text: items.email },
                {
                    action: [
                        '設定変更', '削除'
                    ]
                }
            ]
        }
    });
};


export {
    ACTIONS,
    getAllCompanyAdmin,
    addCompany,
    removeCompany,
    updateCompany,
    searchCompany,
    getAdminClient,
    addClientAdmin,
    deleteClientAdmin,
    updateClientAdmin,
    convertAdminClient,
    searchClient
};
